import dayjs from "dayjs";
import { axiosGet, getAccessToken } from "../../../services/authenticationService";
import axios from "axios";

export async function setSocialToken() {//V5jhbGeVH5
    const currentUserLoginId = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.loginId;
    await axiosGet('https://social-auth-prod.salescode.ai/checkForUser', {
        'token': getAccessToken()??'',
        'loginId': currentUserLoginId
    }).then(function (response) {
        if (response.data['registered'] == true) {
            return response.data['token']
        } else {
            // return axiosGet('create user api', {
            //     'token': 'HLCMK7bwOJ'
            // }).then(function (res) {
            //     return res.data['token'];
            // })
            throw new Error("user not onboarded")
        }
    }).then(function (token) {
        localStorage.setItem('socialToken', token);
    }).catch(function (error) {
        console.log(error);
    });
}

export async function updatePostStatus(status: string, postid: string) {
    const data = {
        updatedStatus: status,
        postid: postid,
    };

    const headers = {
        'Authorization': localStorage.getItem('socialToken') ?? ''
    }
    const res=axios.put(`https://social-api-prod.salescode.ai/posts/updatePostStatus`, data, { headers })
    return  res;
}


export const formatDate = (dateString: string) => {
    const date = dayjs(dateString);

    const day = date.date();
    const suffix = getDaySuffix(day);

    return `${day}${suffix} ${date.format('MMM YYYY [|] h:mm A')}`;
};

const getDaySuffix = (day: number) => {
    if (day > 3 && day < 21) return 'th'; // 4-20 always use "th"
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
};

